
import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Link } from 'react-router-dom';
import { Construction } from 'lucide-react';

const ClientPortal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Header */}
      <section className="pt-32 pb-20 bg-green-100 relative">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <span className="text-green-600 font-display uppercase tracking-wider text-sm mb-2 block animate-fade-up">
              Client Area
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 text-gray-900 animate-fade-up">
              Client Portal
            </h1>
            <p className="text-xl text-gray-700 animate-fade-up">
              Access your account information, view invoices, schedule services, and more.
            </p>
          </div>
        </div>
      </section>
      
      {/* Coming Soon Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <div className="bg-white p-12 shadow-md rounded-lg">
              <Construction className="h-16 w-16 text-pkgreen-500 mx-auto mb-6" />
              <h2 className="text-3xl font-serif font-bold mb-4 text-gray-900">
                Coming Soon
              </h2>
              <p className="text-lg text-gray-700 mb-8">
                We're building a secure client portal where you'll be able to view invoices, 
                schedule services, and manage your account. Stay tuned!
              </p>
              <p className="text-gray-600 mb-8">
                In the meantime, please contact us directly for any account inquiries.
              </p>
              <Link
                to="/contact"
                className="bg-pkgreen-600 hover:bg-pkgreen-700 text-white font-medium py-3 px-8 rounded-md inline-block transition-all duration-300"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ClientPortal;
